import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { GenericEventEmitter } from '../util/eventEmitter';
export var UploadComponent = /*#__PURE__*/function (_ref) {
  _inherits(UploadComponent, _ref);
  var _super = _createSuper(UploadComponent);
  function UploadComponent() {
    _classCallCheck(this, UploadComponent);
    return _super.apply(this, arguments);
  }
  _createClass(UploadComponent, [{
    key: "emitPluginItemsInserted",
    value: function emitPluginItemsInserted(selectedPluginItems) {
      var payload = selectedPluginItems.map(function (item) {
        return {
          pluginName: item.serviceName,
          pluginFile: {
            id: item.id,
            metadata: item.metadata
          }
        };
      });
      this.emit('plugin-items-inserted', payload);
    }
  }, {
    key: "emitUploadsStart",
    value: function emitUploadsStart(files, traceContext) {
      this.emit('uploads-start', {
        files: files,
        traceContext: traceContext
      });
    }
  }, {
    key: "emitUploadPreviewUpdate",
    value: function emitUploadPreviewUpdate(file, preview) {
      this.emit('upload-preview-update', {
        file: file,
        preview: preview
      });
    }
  }, {
    key: "emitUploadEnd",
    value: function emitUploadEnd(file, traceContext) {
      this.emit('upload-end', {
        file: file,
        traceContext: traceContext
      });
    }
  }, {
    key: "emitUploadError",
    value: function emitUploadError(fileId, error, traceContext) {
      this.emit('upload-error', {
        fileId: fileId,
        error: error,
        traceContext: traceContext
      });
    }
  }]);
  return UploadComponent;
}(GenericEventEmitter);